// Story-analyzer endpoint configuration.
//
// TRIL-637: this file used to export BASE_URL, GRAPHQL_URL, WEBSOCKET_URL and two health
// endpoints as well. Every one of them was DEAD — `API_CONFIG.storyAnalyzer` is the only export
// anything consumes — and the dead `GRAPHQL_URL` was one half of the "two disagreeing sources of
// truth" this ticket describes. It resolved differently from `apolloClient.ts` in every mode
// except `development` and `production`, but nothing read it, so the disagreement was inert.
//
// The live harm was the eager `requireEnv` those dead exports needed. It ran at MODULE LOAD, so
// merely importing anything that transitively reached this file threw when VITE_API_URL was
// unset — which is not a hypothetical:
//
//   * `header.test.tsx` carries `vi.stubEnv('VITE_API_URL', …)` with a comment explaining it
//   * `vite.config.ts` grew a `test.env` block (TRIL-620) for the same reason
//
// Two separate workarounds for one landmine, and neither was needed for a value anyone used.
// Both are removed with it.

const isDevelopment = import.meta.env.MODE === 'development';

/**
 * Empty in development ON PURPOSE — the hooks then request `/api/...` relative, which Vite's dev
 * server proxies. Deliberately left keyed on the mode rather than switched to the
 * configuration-first rule used for GraphQL: doing that would make a dev machine with
 * VITE_STORY_ANALYZER_URL in its .env start calling the remote analyzer directly instead of the
 * proxy. That is a behaviour change this ticket has no reason to make.
 *
 * A TRAP THIS CREATES, worth knowing before it costs someone an hour: GraphQL is now keyed on
 * CONFIGURATION while the analyzer below is still keyed on the MODE. So `source .env.demo &&
 * yarn dev` gives a split-brain session — GraphQL against demo, analyzer against the local proxy.
 * The old blanket "any non-production mode is local" rule made that combination impossible.
 * Reconciling the two is TRIL-638, which cannot simply apply the configuration-first rule here
 * without changing what a dev machine talks to.
 */
export const STORY_ANALYZER_URL = isDevelopment
  ? ''
  : (import.meta.env.VITE_STORY_ANALYZER_URL ?? '');

export const API_CONFIG = {
  storyAnalyzer: STORY_ANALYZER_URL,
};
